import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation createMarker($model: CreateMarkerInput!) {
  createMarker(input: $model) {
    id
    name
    description
    directory {
      id
    }
    answerTemplates {
      id
      text
      value
    }
  }
}`;

function createMarker(model) {
  return apollo.client.mutate({
    mutation,
    variables: { model },
  }).then((res) => res.data.createMarker);
}

export default createMarker;
